<template>
	<div>
		<triangle-image
			title="Cassette di Frutta e Verdura<br> a domicilio con Quomi"
		/>

		<div class="container">
			<div class="content">
				<section class="paragraph">
					<h2>
						Filiera corta, qualità e freschezza
					</h2>

					<p>
						Scegli ogni settimana tra le nostre cassette di frutta e verdura a domicilio e di stagione: solo frutta, frutta e verdura o mista con frutta, pane, latte e verdura. Consegna in tutta Italia, anche in ufficio!
					</p>

					<p>
						In più potrai sempre completare la tua spesa grazie ai nostri kit ricetta e ai prodotti dello Shop. Selezioniamo per te solo il meglio da produttori di alta qualità e ti consegniamo tutto nelle giuste quantità e con imballaggi riciclabili ed eco-sostenibili.
					</p>
					<p>
						E per offrire un servizio ancora più su misura è disponibile la consegna a domicilio in tutta Italia e su fascia oraria e fino alle 23 di sera a Milano, Roma e Torino.
					</p>
				</section>

				<section class="paragraph">
					<h2>
						Cosa ricevo con le cassette?
					</h2>

					<p>
						Il contenuto della cassetta varia di settimana in settimana e in base al periodo dell’anno. Riceverai i tuoi prodotti freschi all’interno di una box di cartone, riposti con cura e attenzione per preservare freschezza e qualità. Per esempio in una cassetta di frutta e verdura per 2 persone potresti trovare questa composizione: broccoletto 0,5 kg, carote 0,5 kg, radicchio rosso tondo 0,4 kg, arance navel 1,5 kg, pere abate 1 kg, banane 0,7 kg. Scopri qui sotto le cassette disponibili questa settimana, ordinarle è semplicissimo.
					</p>
				</section>
				<section class="paragraph">

					<h2>Ecco le nostre cassette di Frutta e Verdura di Stagione</h2>
					<div class="center">Ogni settimana puoi aggiungerne una al tuo ordine</div>

					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in recipes" :key="index">
								<a :href="'/ricetta/' + item.url">
									<img :src="item.images.big" :alt='item.title'>
								</a>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>

				</section>

				<router-link
					:to="{name: 'shop-by-tag', params: {tag: 'cassette'}}"
					class="flex flex-center"
				>
					<CTA
						isArrow
						color='green'
							:content="`Ordina ora la tua Cassetta`"
					/>
        </router-link>
				<div class="mt-10">
					<ContinueToShop b2b landing-box-mixed/>	
				</div>
				 <section class="content d-flex flex-column align-items-center">
          <h2 class="p-0">Contattaci per un preventivo gratuito</h2>
          <p class="text-center mt-0 mb-3">Lascia i tuoi recapiti e ti contatteremo entro 2 giorni lavorativi per inviarti un'offerta personalizzata e senza impegno.</p>
          <div class="request-info col-sm-8">
            <form
              role="form"
              method="POST"
              name="newsletter"
              action=""
              class="form"
              :class="{'flex': $mq.isDesktop() }"
              @submit.prevent="startSpinner($_newsletter_newsletterList({ email: email, name: name, business_name: business_name, list: 'business' }))"
            >
              <input 
              type="text"
              class="form-control"
              v-model="name"
              required 
              placeholder="Il tuo nome"
              />
              <input 
              type="text"
              class="form-control"
              v-model="business_name"
              required 
              placeholder="La tua azienda"
              />
              <input
                type="email"
                class="form-control"
                v-model="email"
                required
                placeholder="La tua mail"
                autocomplete="email"
              >
              <CTA
                :content="`Invia`"
                :size="`small`"
                type="submit"
                :loading="loadSpinner"
                :disabled="newsletterLoading"
                :class="{'cta': !$mq.isDesktop() }"
              />
            </form>
          </div>
          <strong class="pt-3" v-if="checkMailSent === true">La tua richiesta è stata inviata!</strong>
          <div class="small-text">
            Inviando la richiesta accetti le <router-link :to="{name: 'privacy-policy'}" :title='$t("components.checkbox.general_conditions")' target='_blank'>condizioni relative alla privacy</router-link>.
          </div>
        </section>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
	import Slick from '../Slick'
	import { goSlick } from '../../assets/js/slick'
	import { AllRecipesApi } from '../../api/AllRecipesApi'
	import ContinueToShop from '../Parts/ContinueToShop'

	export default {
	components: {
		TriangleImage,
		Slick,
		ContinueToShop
	},

	data () {
		return {
			recipes: null,
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		loadRecipes () {
			var rm = new AllRecipesApi()
			return rm.get({
				params: {
					show: 10,
					page: 1,
					sort_direction: 'asc',
				},
				query: `product.scopeTags.name ct 'box-mixed'`
			})

			.then(response => {
				this.recipes = response.body.data.resources
			})

			.catch(response => {
			})
		}
	},

	mounted () {
		this.loadRecipes()

		.then(response => {
			goSlick()
		})
	}

}
</script>

<style scoped>

.slick-slide >>> .recipe-name.small {
	font-size: 12px;
	text-align: left;
	min-height: 55px;
}

.triangle-image {
	background: url("../../assets/img/covers/cover-box-mixed.jpg");
	background-position: center 40%;
	background-repeat: no-repeat;
	background-size: cover;
}

.center {
	text-align: center;
}


.content {
	max-width: 800px;
} 

h2 {
	text-align: center;
}

.paragraph p {
  margin-bottom: 45px;
}

.request-info form {
	display: flex;
	flex-direction: column;
}

.request-info button {
	width: 50%;
	align-self: center;
}

.small-text {
	font-size: 13px;
	padding-top: 10px;
}

.small-text a {
	text-decoration: underline;
}

@media (max-width: 1024px) {
	.triangle-image >>> h1 {
		font-size: 30px;
	}
}

</style>
